import {Component, Inject, OnInit} from "@angular/core";
import {AlertService, AuthenticationService} from "../../_services";
import {Router} from "@angular/router";
import {LoginHelper} from "../../helpers";
import {User} from "../../_models";
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {ImplementationControlStatement} from "../../_models/implementationControlStatement";
import {DictionaryService} from "../../_services/dictionary.service";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";

@Component({
  standalone: false,
  selector: "addSignature-item",
  templateUrl: 'addSignature.component.html',
  styleUrls: ['./addSignature.component.scss'],
})
export class AddSignatureComponent {
  currentUser: User;
  form: FormGroup;

  constructor(
    public authenticationService: AuthenticationService,
    public alertService: AlertService,
    public dictionaryService: DictionaryService,
    public formBuilder: FormBuilder,
    @Inject(MAT_DIALOG_DATA) data: any,
    public dialogRef: MatDialogRef<AddSignatureComponent>) {
    this.form = formBuilder.group({
      name: ['', Validators.required],
      date: ['', Validators.required]
    });
  }

  onClose(){
    this.dialogRef.close();
  }

  sign() {
    if (this.form.valid) {
      this.dialogRef.close(this.form.value);
    }
  }
}
